module.exports = require('./lib/targz.js');